import './modules/jotform';
import './modules/ko-bindings';

// app -> account
import './app/account/account';
import './app/account/account-child';
import './app/account/account-edit';
import './app/account/account-order-details';

// app -> about
import './app/about/join-the-team';

// app -> programs
import './app/programs/program-levels';

// app -> register
import './app/register/place-search';
import './app/register/register';
import './app/register/review';
import './app/register/options';
import './app/register/checkout';
import './app/register/waitlist';

// app -> support
import './app/support/chinese-support';
import './app/support/contact-us';

// app -> user
import './app/user/change-password';
import './app/user/forgot-password';
import './app/user/set-password';
import './app/user/sign-in';